import * as styles from './terms.style.js';
import { cx } from '@emotion/css';

export default function Terms() {
  return (
    <main className={cx(styles.main)}>
      <section class="main content">
        <hgroup>
          <h1>QuizWizard Privacy Policy</h1>
          <h2>
            Effective date: Jan 1, 2022; Last updated: Sept 21, 2022
          </h2>
        </hgroup>

        <p>
          QuizWizard is dedicated to helping people around the world practice
          and master whatever they are learning in a fun way.When you share information with
          us we can help you achieve that goal by helping you find the right
          content and making your studying quicker and more effective. This
          Privacy Notice is meant to help you understand how we collect and use
          the personal information you provide when you use our Service,
          including through our website and mobile applications. This notice
          explains:
        </p>
        <ul
          style={{
            'list-style': 'disc',
          }}
        >
          <li>The information we collect and where we collect it from</li>
          <li>The ways we use your information</li>
          <li>The times where we might need to share information</li>
          <li>
            Choices you have about what we do and how to exercise your choices
          </li>
          <li>How to contact us if you have questions</li>
        </ul>

        <h3>Information We Collect and Sources</h3>
        <p>
          We need to collect certain information about you to provide you with
          the Service or the support you request. The type of information we
          collect can vary depending on how you access and use our Service.
          Additionally, you can choose to voluntarily provide information to us.
          Below we have described the types of information we collect and from
          where we collect it.
        </p>

        <h4>Information you Provide to Us to Use the Service</h4>
        <p>
          <strong>Account information</strong>. We collect the information you
          provide when you sign up for a QuizWizard account, log in to your
          account, communicate with us, answer our surveys, upload content, or
          otherwise use the Services. We request an email address and grade information
          when you choose to sign up for the Service so we can provide the
          Services to you and allow us to comply with applicable regulations.
          Without this information, we are not be able to provide you with the
          Service.
        </p>
        <p>
          <strong>Transactional information</strong>. Presently we do not support any financial transactions in our site.
        </p>

        <h4>Information You Provide to Enhance Your Experience</h4>
        <p>
          You can choose to provide us with additional information in order to
          obtain a better user experience when using the Service. This
          additional information will be processed with your consent and/or to
          provide you with services you request. This information includes your
          survey responses, participation in contests, promotions or other
          marketing efforts, suggestions for improvements, referrals, or any
          other actions on the Service.
        </p>

        <h4>Information We Get Automatically When You Use the Service</h4>
        <p>
          We automatically collect information about you and how you use the
          Service, like when you create a batch/assignment or attend events/practice events. This information we
          collect includes:
        </p>
        <p>
          <strong>Device information</strong>. Like most website operators,
          QuizWizard collects information about how users visit our site and the
          devices they use. We collect device-specific information (such as your
          hardware model, operating system version, device identifiers like IDFA
          and UDID, and mobile network information).
        </p>
        <p>
          <strong>Geolocation information</strong>. We may use your IP address
          to generate a general approximation of where you are located in order
          to provide you with an improved experience. We do not request access
          to or collect location sensor information, such as GPS or Bluetooth
          beacons, from your mobile device while downloading or using our mobile
          apps or services.
        </p>
        <p>
          <strong>Log information</strong>. When you use QuizWizard, we
          automatically collect and store certain information about this
          activity. This data includes details of how you used our service, like
          your search queries, clicks and site navigation information, or study
          activity. It also may include data such as:
        </p>
        <ul
          style={{
            'list-style': 'disc',
          }}
        >
          <li>Browser type</li>
          <li>Language preference and time zone</li>
          <li>Referring site, and the date and time of each visitor request</li>
          <li>Connection information like ISP or mobile operator</li>
          <li>Internet Protocol (IP) address</li>
          <li>Log-in and Log-out times</li>
        </ul>

        <p>
          <strong>Third Party Service Providers</strong>. We use a restricted
          version of Hotjar to limit data sharing and tracking on
          areas of our site and mobile apps that are accessed by users. We use Amazon WebServices to store data.
        </p>
        <p>
          <strong>Parental Rights</strong>. Parents and legal guardians of
          children under 13 can consent to collection and use of a child's
          personal information without consenting to the disclosure of that
          information to third parties. Parents or guardians can review
          information their children under 13 have contributed to QuizWizard by
          accessing their child's account via password reset. Parents can also
          request that QuizWizard delete that information and refuse to allow
          QuizWizard to collect further information from their children by
          contacting QuizWizard at{' '}
          <a href="mailto:admin@quizwizard.net" target="email">
            admin@quizwizard.net
          </a>.
          QuizWizard may ask additional questions or take other steps to
          verify the identity of a parent or guardian before responding to a
          request to review or delete a child's information or a request to
          refuse further collection from a child.
        </p>

        <h3>How We Use Your Information</h3>
        <p>
          We collect information about you when you use the Service for a
          variety of reasons in order to support QuizWizard and to enable our team
          to continue to create engaging experiences for our users.
        </p>

        <h4>Providing, Analyzing, Improving and Developing the Service</h4>
        <p>
          We process the data we collect about you to operate, improve and
          develop the QuizWizard Service, including providing, maintaining,
          securing and improving our services, developing new ones, and
          protecting QuizWizard and our users. We are able to deliver our services,
          personalize content, and make suggestions for you by using this
          information to understand how you use and interact with our services.
          We conduct surveys and research, test features in development, and
          analyze the information we have to evaluate and improve products and
          services, develop new products or features, and conduct audits and
          troubleshooting activities.
        </p>
        <p>Here are some examples of how we use this information:</p>
        <ul
          style={{
            'list-style': 'disc',
          }}
        >
          <li>
            <strong>Providing, maintaining and improving the Service</strong>.
            Account information we collect from you allows us to help you log
            in, host your content, and use the various study tools we have. It
            also allows us learn about how you and others use QuizWizard to help
            create new activities and services, like Quiz Live Challenges.
          </li>
          <li>
            <strong>
              Improving, personalizing and facilitating your use of the Service
            </strong>
            . When you sign up and use a QuizWizard account, we may associate
            certain information with your new account, such as information about
            other QuizWizard accounts you had or currently have, and your prior
            usage of the Service. For example, we use information collected from
            cookies and other technologies, like pixel tags, to save your
            language preferences, so we will be able to have our services appear
            in the language you prefer. We do this in order to ensure that
            content from the Service is presented in the most effective manner
            for you.
          </li>
          <li>
            <strong>
              Measuring, tracking and analyzing trends and usage in connection
              with your use or the performance of the Service
            </strong>
            . In order to develop and enhance our products and deliver a
            consistent, secure and continuous experience, we need gather certain
            information to analyze usage and performance of the Service. We also
            use mobile analytics software to pursue our legitimate interests in
            operating and improving QuizWizard by allowing us to better understand
            the functionality of our mobile software on your device. This
            software may record information such as how often you use the
            application, the events and activities that occur within the
            application, aggregated usage, performance data, and where the
            application was downloaded from.
          </li>
          <li>
            <strong>
              Fulfilling any other purpose disclosed to you in connection with
              the Service.
            </strong>
          </li>
        </ul>

        <h4>Communicating with You About the Service</h4>
        <p>
          We also use your account information and information you provide to us
          to provide you with relevant information about the Service and to
          assist you in using the Service if required. These communications may
          include:
        </p>
        <ul
          style={{
            'list-style': 'disc',
          }}
        >
          <li>
            <strong>
              Sending you information we think you may find useful or which you
              have requested from us about our products and services
            </strong>
            . We may send you information about the parts of QuizWizard you use or
            that may be relevant to you. While we primarily use our various
            product blogs to communicate this type of information and we expect
            to keep this type of email to a minimum, you may object to being
            contacted for these reasons using your personal contact information
            using the support email id
          </li>
          <li>
            <strong>
              Sending you reports of the events you attended and progress report.
            </strong>
            Parents/Teachers/Students will get reports of the challenges which were assigned by them to their batch.
          </li>

          <li>
            <strong>
              Conducting surveys and collecting feedback about the Service
            </strong>
            . We do this to evaluate the effectiveness of any updates we
            provide.
          </li>
          <li>
            <strong>Delivering assistance or answering support requests</strong>
            . We send you the information and support you request, including
            technical notices, security alerts, and other administrative
            messages to provide assistance for problems you may encounter with
            the Service or your QuizWizard account.
          </li>
        </ul>

        <h4>Protecting the Service and Maintaining a Trusted Environment</h4>
        <p>
          We use all categories of information we collect to maintain QuizWizard as
          a safe and secure platform for all our users, including appropriate
          enforcement of QuizWizard policies, as well as compliance with the law
          and applicable regulations. These efforts include:
        </p>
        <ul
          style={{
            'list-style': 'disc',
          }}
        >
          <li>
            <strong>
              Preventing fraud, crime and abuse and the security and integrity
              of the Service
            </strong>
            . This includes investigating, detecting and preventing or reporting
            fraud, misrepresentations, security breaches or incidents, other
            potentially prohibited or illegal activities or to otherwise help
            protect your account.
          </li>
          <li>
            <strong>
              Protecting our and third parties’ rights and property and
              enforcing our Terms of Service or other applicable agreements or
              policies, including our Community Guidelines and Honor Code.
            </strong>
          </li>
          <li>
            <strong>Verifying your identity</strong>. In some cases, we may need
            to verify your identity in order to protect the security and
            integrity of the Service and your account.
          </li>
          <li>
            <strong>Complying with any applicable laws or regulations</strong>.
            This includes appropriately responding to lawful requests for
            information from the government or third parties through legal
            process.
          </li>
          <li>
            <strong>
              Contacting you to resolve disputes, collect fees and provide
              assistance with the Service.
            </strong>
          </li>
        </ul>

        <h4>Advertising, Analytics and Marketing</h4>
        <p>
          In order to support the QuizWizard business and provide our users with
          relevant information regarding the Service and opportunities presented
          by partners, QuizWizard may use your personal information for marketing
          the Service. We may also communicate with you and others about
          opportunities, products, services, contests, promotions, discounts,
          incentives, surveys, and rewards offered by us and select partners. We
          may also displaying relevant advertising to you while using the
          Service.
        </p>

        <h4>Cookies and Other Similar Technologies</h4>
        <p>
          Technologies such as cookies, beacons, tags and scripts are used by
          QuizWizard and our partners' affiliates, or analytics or service
          providers, to collect and store data about our users in order to
          provide the Service in accordance with our agreement with you under
          the Terms of Service and are an essential technology for allowing
          QuizWizard to pursue our legitimate interests in operating and improving
          the Service. Cookies can be turned off using browser settings. This may result in some functionalities not working right.
        </p>


        <h4>Information We Combine</h4>
        <p>
          We also collect some information from other sources and combine that
          with information we collect from you. To ensure a proper experience on
          QuizWizard, we combine information collected across devices, such as
          computers and mobile devices.
        </p>

        <h4>Other Uses</h4>
        <p>
          We may process data for any other purpose disclosed to you in
          connection with the Service from time to time. If we intend to process
          your personal data for a purpose other than that set out above and
          which is not compatible with the original processing purpose, we will
          provide you with relevant information prior to such processing and
          will obtain your consent where necessary.
        </p>

        <h3>How your Information Is Shared</h3>

        <h4>Information You Choose to Share on QuizWizard</h4>
        <p>
          Certain information about you or activities you perform on QuizWizard may
          be displayed publicly, for example, information included on your user
          profile, challenges you have joined, high scores you have achieved, or
          sets you have studied may be visible to others.
        </p>

        <h4>How QuizWizard Shares Information</h4>
        <p>QuizWizard shares your information in the following circumstances:</p>
        <p>
          <strong>With your consent</strong>. We will share personal information
          with companies, organizations or individuals outside of QuizWizard when
          we have your consent to do so.
        </p>
        <p>
          <strong>For external processing</strong>. QuizWizard provides personal
          and non-personal information to our partners, trusted organizations,
          vendors and other affiliated organizations to process it on our
          behalf. Some of these contractors and affiliated organizations may be
          located outside of your home country. Our providers process data in
          accordance with our instructions, Privacy Notice and any other
          appropriate confidentiality, security or other requirements we deem
          necessary in order to comply with QuizWizard’s obligations. By using
          QuizWizard, you agree to allow these companies to process your data on
          our behalf, regardless of where they are located.
        </p>
        <p>
          <strong>
            To respond to legal and other requests and to prevent harm
          </strong>
          . QuizWizard will share all categories of personal information with
          companies, organizations or individuals outside of QuizWizard if we have
          a good-faith belief that access, use, preservation or disclosure of
          the information is reasonably necessary to:
        </p>
        <ul
          style={{
            'list-style': 'disc',
          }}
        >
          <li>
            Respond to or meet any applicable law, regulation, legal process or
            other enforceable governmental request.
          </li>
          <li>
            Enforce our Terms of Service, including investigation of potential
            violations.
          </li>
          <li>
            Detect, prevent, or otherwise address fraud, security or technical
            issues.
          </li>
          <li>
            Protect against and prevent harm to the rights, property or safety
            of QuizWizard, our users or the public as required or permitted by law.
          </li>
        </ul>
        <p>
          <strong>With any successor to all or part of our business</strong>. If
          QuizWizard is involved in a merger, acquisition, or sale of all or a
          portion of its assets, you will be notified via email and/or a
          prominent notice on our website of any change in ownership or uses of
          your personal information, as well as any choices you may have
          regarding your personal information.
        </p>
        <p>
          <strong>For research purposes</strong>. From time to time, QuizWizard may
          release non-personal information in the aggregate or as part of
          anonymized datasets, for example, by publishing a report on trends in
          the usage of its website.
        </p>

        <a name="choices"></a>
        <h3>Your Choices About How We Use Your Information</h3>

        <h4>Promotional Communications</h4>
        <p>
          You may receive promotional email messages from QuizWizard when you first
          interact with the Service or by making a request to us. You can opt
          out of receiving promotional email messages from QuizWizard at the time
          we collect your information by following the instructions on screen,
          in those email messages, or by changing your notification settings in
          your QuizWizard account. Opting out of receiving communications may
          impact your use of the Services. If you decide to opt out, we will
          still send you non-promotional communications, such as digital
          receipts and messages about your account or our ongoing business
          relations.
        </p>

        <h4>Who Can View Information You Post</h4>
        <p>
          Comments you post on our blog or in testimonials may be viewable by
          other users of QuizWizard and the general public and you should be aware
          that any information you provide in these areas may be read,
          collected, and used by others who access them. To request removal of
          your personal information from these areas, contact us at the support email id.
          . We provide you the ability to control who can view and modify the
          content you have created on QuizWizard and to remove information about
          previous study sessions. In some cases, we may not be able to remove
          your personal information, in which case we will let you know if we
          are unable to do so and why.
        </p>



        <a name="managing_your_account"></a>
        <h4>Managing Your Account</h4>
        <p>
          You remain in control of the information you provide to QuizWizard. You
          may review, edit or delete any information you submit to us at any
          time by signing into your QuizWizard account; however, deletion of this
          information may restrict your ability to effectively use the Service.
          You may also delete your account at any time. If you delete your
          account, all the study sets, folders, and classes that you've created
          will also be also deleted in accordance with our data retention
          practices.
        </p>


        <h4>California and Nevada Resident Rights</h4>
        <p>
          <strong>California residents’ rights</strong>. If you reside in
          California and are not a job applicant, employee, or employee of
          another company interacting with us in your job role, you have the
          right to request what information we collect, use, and disclose. You
          also have the right to request that we delete your information. The
          easiest mechanism is to log in to your account and delete your account
          using the option available on your Settings page. To make a request
          you can
          email us at{' '}
          <a href="mailto:admin@quizwizard.net" target="email">
            admin@quizwizard.net
          </a>
          . For requests submitted through our support team, we may need to take
          additional steps to verify you are the owner of the account, including
          confirming certain account information and ownership of the email
          address linked to the account. We will not discriminate against you
          because you have exercised any of your privacy rights under the
          California Consumer Privacy Act. You can designate an agent to make a
          request by having them execute a notarized power of attorney to act on
          your behalf.
        </p>
        <p>
          <strong>Sales of personal information</strong>. Under California law,
          we are required to tell California residents if we “sell” information
          as that term is defined by applicable law. “Sell” means to share
          personal information with a third party for monetary or other valuable
          consideration. California residents, we do not sell your personal
          information based on our understanding of that term. We also have
          disclosure obligations in Nevada. We do not exchange Nevada residents’
          personal information for money with anyone so they may license or sell
          the personal information to additional parties. We do not sell
          personal information of minors under the age of 16. Nevada residents
          may opt out of the future sale of their information to a third party
          so that they may license or sell information by emailing us at:{' '}
          <a href="mailto:admin@quizwizard.net" target="email">
            admin@quizwizard.net
          </a>
          .
        </p>

        <h3>We Store Information In the United States</h3>
        <p>
          While QuizWizard operates internationally, our systems are based
          in the United States
        </p>


        <h3>How Long We Retain Your Information</h3>
        <p>
          QuizWizard retains your personal information for as long as your account
          is active, to fulfill our legitimate business purposes, or to comply
          with our legal obligations. When these conditions no longer exist,
          QuizWizard removes that information in accordance with our standard
          deletion processes. QuizWizard may retain and use non-personal
          information, including information which has been de-identified,
          aggregated, or anonymized, indefinitely.
        </p>
        <p>
          We retain records of support tickets and other communications between
          QuizWizard and our users, for example support emails, survey responses,
          feedback submissions, or comments on our blogs or other posts,
          indefinitely in order to better manage our support processes,
          maintaining accurate business records, and identifying other trends.
          We reserve the right to publish these communications in order to help
          us clarify or respond to your request or to help us support other
          users.
        </p>

        <h3>How We Secure Your Information</h3>
        <p>
          The security of your personal information is important to us. QuizWizard
          takes measures reasonably designed to protect against the unauthorized
          access, use, alteration or destruction of personal information.
        </p>
        <p>
          We use our best efforts to follow generally accepted industry
          standards to protect the personal information submitted to us, both
          during transmission and once we receive it. For example, our website
          and apps are designed to be protected by HTTPS encryption. However, the Internet is not 100% secure. We cannot
          promise that your use of our sites will be completely safe. We
          encourage you to use caution when using the Internet. If you have any
          questions about security on our website, you can contact us at{' '}
          <a href="mailto:admin@quizwizard.net" target="email">
            admin@quizwizard.net
          </a>
          .
        </p>




        <h3>Changes to this Notice</h3>
        <p>
          QuizWizard reserves the right to modify this Privacy Notice at any time,
          so please review it frequently. If we materially change how we use
          your personal information, we will notify, by email, and/or by means
          of a notice on our website prior to the change becoming effective. If
          you disagree with these changes, you can delete your account at any
          time and/or stop using the Service. Your continued use of the Service
          constitutes your acceptance of any changes to this Privacy Notice.
        </p>
        <p>
          If we make material changes to how we collect and use personal
          information from children under the age of consent, we will notify
          parents by email and, when appropriate, obtain additional parental
          consent for the new uses of the child's personal information.
        </p>

        <h3>Contact Us</h3>
        <p>
          If you have questions or wish to send us comments about this Privacy
          Notice, please write us:
        </p>
        <p>
          <a href="mailto:admin@quizwizard.net" target="email">
            admin@quizwizard.net
          </a>
          <br />

        </p>
      </section>
    </main >
  );
}
